var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataSystemActiveConnection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.25C5.58579 8.25 5.25 8.58579 5.25 9C5.25 9.41421 5.58579 9.75 6 9.75V8.25ZM6 0.25C5.58579 0.25 5.25 0.585786 5.25 1C5.25 1.41421 5.58579 1.75 6 1.75V0.25ZM9.25 5C9.25 6.79493 7.79493 8.25 6 8.25V9.75C8.62335 9.75 10.75 7.62335 10.75 5H9.25ZM6 1.75C7.79493 1.75 9.25 3.20507 9.25 5H10.75C10.75 2.37665 8.62335 0.25 6 0.25V1.75Z",
    fill: "#00AB21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5L6 5",
    stroke: "#00AB21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5H15",
    stroke: "#00AB21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 5,
    r: 2,
    fill: "#00AB21"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataSystemActiveConnection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataSystemActiveConnection.a8fd0d361a92dd7edf5c9b9e4b0fbf2c.svg";